import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function HeroSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language];
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="home" className="relative min-h-screen flex items-center justify-center" data-id="element-106">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/9bpVB7494NrabK3vmLYw1Y/hero.jpg')`
    }} data-id="element-107">
        {/* Dark Overlay for Text Readability - lighter at top for header visibility */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/70" data-id="element-108"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-109">
        {/* Semi-transparent box behind text */}
        <div className="backdrop-blur-sm rounded-2xl px-8 py-12 sm:px-12 sm:py-16 shadow-2xl bg-[#1118275B]" data-id="element-110">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-111">
            {t.hero.title}
          </h1>
          <p className="text-xl sm:text-2xl text-white/90 mb-8 leading-relaxed" data-id="element-112">
            {t.hero.subtitle}
          </p>
          <button onClick={scrollToAbout} className="inline-block px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg shadow-lg transition-all duration-300 hover:bg-blue-700 hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-blue-500/50" aria-label="Learn more about our services" data-id="element-113">
            {t.hero.cta}
          </button>
        </div>
      </div>
    </section>;
}